import { AppBar, Breadcrumbs, Hidden, Link, Typography, useTheme } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import Separator from "../../components/icons/Separator";
import { useMapThemeClasses } from "../../hooks/use-map-theme-styles";
import { BreadcrumbProps } from "../../store/layout";
import useStyles from "./layout-styles";

type LocalBreadcrumbProps =
	| BreadcrumbProps
	| {
			disableSticky: boolean;
			fromProps?: false;
			links?: null;
	  };

const Breadcrumb: React.FC<LocalBreadcrumbProps> = ({ fromProps, links, disableSticky }) => {
	const { palette } = useTheme();
	const { push } = useHistory();
	const { breadcrumbs } = useStyles();
	const { breadCrumbRoot } = useMapThemeClasses();
	const [isScrolling, setIsScrolling] = useState(false);

	const breadCrumbsEnabled = fromProps ? !!links?.length : false;

	const changeNavbarColor = () => {
		if (!breadCrumbsEnabled) return;
		if (window.scrollY >= 20) {
			setIsScrolling(true);
		} else {
			setIsScrolling(false);
		}
	};

	window.addEventListener("scroll", changeNavbarColor);

	const LinkComponent = (props: { link: string; name: string | number | undefined; index?: number }) => (
		<Link
			key={props.index}
			color="primary"
			href={props.link}
			onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => handleClick(e, props.link)}
		>
			{props.name}
		</Link>
	);

	function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, link: string) {
		event.preventDefault();
		push(link);
	}

	if (!links?.length) return <></>;

	return (
		<Hidden xsDown>
			<AppBar
				classes={{ root: breadCrumbRoot }}
				style={!isScrolling ? { backgroundColor: "transparent", boxShadow: "none" } : undefined}
				position={disableSticky === true ? "absolute" : "sticky"}
			>
				<Breadcrumbs
					separator={<Separator color={palette.primary.main} />}
					aria-label="breadcrumb"
					itemsBeforeCollapse={1}
					itemsAfterCollapse={2}
					classes={{ root: breadcrumbs }}
				>
					{fromProps &&
						links?.map((l, i) =>
							l.link ? (
								<LinkComponent key={i} link={l.link} name={l.label} />
							) : (
								<Typography style={{ color: palette.mainText.main }} variant="inherit" key={i}>
									{l.label}
								</Typography>
							)
						)}
				</Breadcrumbs>
			</AppBar>
		</Hidden>
	);
};

export default Breadcrumb;
